import { render, staticRenderFns } from "./wareDetail.vue?vue&type=template&id=4be606d3&scoped=true"
import script from "./wareDetail.vue?vue&type=script&lang=js"
export * from "./wareDetail.vue?vue&type=script&lang=js"
import style0 from "./wareDetail.vue?vue&type=style&index=0&id=4be606d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be606d3",
  null
  
)

export default component.exports